export default __webpack_public_path__ + "static/media/hundredpercent.41099baa.gif";